import FileSaver from 'file-saver'
import React from 'react'
import Translation from 'utils/Language/Translation'
import { PeripheralPrinter } from "utils/PeripheralManager"
import { confirm } from 'utils/Prompts'

const MaintenanceComponent = ({device}: {device: DownloadPrint}) => {
  return (
    <>
      
    </>
  )
}

class DownloadPrint implements PeripheralPrinter<DownloadPrint> {
  getDriverName = () => 'DownloadPrint'

  connect = async (data: any) => {}

  disconnect = async () => {}

  isConnected = async () => { return true }

  print = async (mediatype: string, payload: string) => {
    // if zpl then allow pre conversion
    if (mediatype === 'x-application/zpl' && (await confirm(<Translation name="T.warnings.doYouWantToConvertTheZplToAnImage"/>))) {
      const pngs = await window.be_api.printers.convertZpl2img({ zplData: atob(payload) })
      let i = 0;
      for (const png of pngs) {
        const data = Uint8Array.from(atob(png).split('').map(char => char.charCodeAt(0)));  
        const file = new Blob([data], {type: 'image/png'});
        FileSaver.saveAs(file, `image ${++i}.png`);
      }
      return
    }

    // download the file
    const data = Uint8Array.from(
      atob(payload as any).split('').map(char => char.charCodeAt(0))
    );  
    const file = new Blob([data], {type: mediatype});
    FileSaver.saveAs(file);
  }

  getMaintenanceComponent = () => MaintenanceComponent
}

export default DownloadPrint